// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-manager {
         
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          color: #333;
         
          margin: 0 auto;
        }
        
        h2 {
          margin: 0 0 5px 0;
          color: #2c3e50;
        }
        
        .subtitle {
          color: #7f8c8d;
          margin: 0 0 25px 0;
        }
        
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 20px;
          margin-bottom: 30px;
        }
        
        .stat-card {
          background: white;
          border-radius: 8px;
          padding: 20px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          display: flex;
          align-items: center;
        }
        
        .stat-icon {
          color: #6b7280; /* Tailwind gray-500 */
          font-size: 2em;
          margin-bottom: 8px;
          margin-right: 15px;
        }
        
        .stat-content h3 {
          margin: 0;
          font-size: 1.8rem;
          color: #2c3e50;
        }
        
        .stat-content p {
          margin: 5px 0 0 0;
          color: #7f8c8d;
        }
        
        .upload-section {
          background: white;
          border-radius: 8px;
          padding: 20px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          margin-bottom: 20px;
        }
        
        .upload-section h3 {
          margin: 0 0 15px 0;
          color: #2c3e50;
        }
        
        .upload-area {
          border: 2px dashed #ddd;
          border-radius: 8px;
          padding: 20px;
          text-align: center;
        }
        
        .file-input {
          width: 100%;
          margin-bottom: 15px;
        }
        
        .upload-button {
          background: #3498db;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 4px;
          cursor: pointer;
          margin-top: 15px;
        }
        
        .upload-button:hover {
          background: #2980b9;
        }
        
        .filters-section {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
          flex-wrap: wrap;
          gap: 15px;
        }
        
        .search-box input {
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 4px;
          width: 250px;
        }
        
        .filter-group {
          display: flex;
          gap: 10px;
        }
        
        .filter-group select {
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 4px;
          background: white;
        }
        
        .files-table-container {
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          overflow: hidden;
        }
        
        .loading, .no-files {
          padding: 40px;
          text-align: center;
          color: #7f8c8d;
        }
        
        .files-table {
          width: 100%;
          border-collapse: collapse;
        }
        
        .files-table th {
          background: #f8f9fa;
          padding: 8px;
         
          font-weight: 600;
          color: #2c3e50;
          border-bottom: 1px solid #ddd;
        }
        
        .files-table td {
          padding: 8px;
          border-bottom: 1px solid #eee;
        }
        
        .files-table tr:hover {
          background: #f8f9fa;
        }
        
        .file-info {
          display: flex;
          align-items: flex-start;
        }
        
        .file-icon {
          color: #6b7280; /* Tailwind gray-500 */
          font-size: 1.5em;
          margin-right: 10px;
          vertical-align: middle;
        }
        
        .file-title {
          font-weight: 600;
          color: #2c3e50;
        }
        
        .file-name {
          font-size: 0.9rem;
          color: #7f8c8d;
          margin: 2px 0;
        }
        
        .file-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 5px;
          margin-top: 5px;
        }
        
        .tag {
          background: #e8f4fd;
          color: #3498db;
          padding: 2px 8px;
          border-radius: 12px;
          font-size: 0.8rem;
        }
        
        .vault.internal {
          color: #27ae60;
          font-weight: 600;
        }
        
        .vault.external {
          color: #3498db;
          font-weight: 600;
        }
        
        .status.active {
          color: #27ae60;
          font-weight: 600;
        }
        
        .status.processing {
          color: #f39c12;
          font-weight: 600;
        }
        
        .access.public {
          color: #27ae60;
          font-weight: 600;
        }
        
        .access.restricted {
          color: #f39c12;
          font-weight: 600;
        }
        
        .access.confidential {
          color: #e74c3c;
          font-weight: 600;
        }
        
        .uploader {
          font-size: 0.8rem;
          color: #7f8c8d;
          margin-top: 3px;
        }
        
        .actions {
          display: flex;
          gap: 8px;
        }
        
        .actions button {
          background: none;
          border: 1px solid #ddd;
          border-radius: 4px;
          padding: 5px 8px;
          cursor: pointer;
          font-size: 1rem;
        }
        
        .actions button:hover {
          background: #f8f9fa;
        }
        
        .delete-btn:hover {
          color: #e74c3c;
          border-color: #e74c3c;
        }
        
        @media (max-width: 768px) {
          .filters-section {
            flex-direction: column;
          }
          
          .search-box input {
            width: 100%;
          }
          
          .filter-group {
            width: 100%;
            justify-content: space-between;
          }
          
          .files-table {
            display: block;
            overflow-x: auto;
          }
        }


        .file-manager-container {
  padding: 20px;
  max-width: 100%;
  margin: 100px auto 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.file-manager-header {
  margin-bottom: 24px;
}

.file-manager-header h2 {
  color: #2c3e50;
  margin: 0 0 8px 0;
  font-weight: 600;
}

.subtitle {
  color: #7f8c8d;
  margin: 0;
  font-size: 16px;
}

.controls-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 15px;
}

.search-box {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1;
  min-width: 300px;
  max-width: 500px;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #95a5a6;
}

.search-box input {
  width: 100%;
  padding: 10px 15px 10px 40px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s;
}

.search-box input:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

.controls-right {
  display: flex;
  gap: 10px;
}

.refresh-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #ecf0f1;
  border: 1px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
}

.refresh-btn:hover:not(:disabled) {
  background-color: #dfe6e9;
}

.refresh-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.table-responsive {
  overflow-x: auto;
  width: 100%;
}

.messages-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;
}

.messages-table th {
  background-color: #f8f9fa;
  padding: 12px 15px;
  text-align: left;
  font-weight: 600;
  color: #2c3e50;
  border-bottom: 2px solid #e9ecef;
  cursor: pointer;
  transition: background-color 0.3s;
  position: relative;
}

.messages-table th:hover {
  background-color: #e9ecef;
}

.column-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sort-indicator {
  margin-left: 5px;
  font-weight: bold;
}

.messages-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #e9ecef;
  vertical-align: top;
  font-size: 14px;
  color: #34495e;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.messages-table tr:hover {
  background-color: #f8f9fa;
}

.array-container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.array-item {
  background-color: #e3f2fd;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  color: #1976d2;
}

.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.action-btn {
  padding: 6px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-btn.view {
  background-color: #e3f2fd;
  color: #1976d2;
}

.action-btn.download {
  background-color: #e8f5e9;
  color: #388e3c;
}

.action-btn.delete {
  background-color: #ffebee;
  color: #d32f2f;
}

.action-btn:hover {
  opacity: 0.8;
  transform: scale(1.05);
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #95a5a6;
  text-align: center;
}

.empty-state h3 {
  margin: 16px 0 8px;
  color: #7f8c8d;
}

.pagination {
  display: flex;
  justify-content: center;
  padding: 20px;
  gap: 8px;
}

.pagination button {
  padding: 8px 12px;
  border: 1px solid #ddd;
  background-color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.pagination button:hover:not(:disabled):not(.active) {
  background-color: #f1f1f1;
}

.pagination button.active {
  background-color: #3498db;
  color: white;
  border-color: #3498db;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.table-info {
  padding: 0 20px 20px;
  text-align: center;
  color: #7f8c8d;
  font-size: 14px;
}

@media (max-width: 768px) {
  .file-manager-container {
    padding: 15px;
    margin-top: 80px;
  }
  
  .controls-section {
    flex-direction: column;
    align-items: stretch;
  }
  
  .search-box {
    min-width: 100%;
  }
  
  .messages-table th, 
  .messages-table td {
    padding: 8px 10px;
    font-size: 13px;
  }
  
  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }
}

.bareedy-card {
  transition: box-shadow 0.2s;
}
.bareedy-card:hover {
  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.12);
}
.action-btn {
  cursor: pointer;
  transition: background 0.2s;
}
.action-btn:hover {
  filter: brightness(0.95);
}`, "",{"version":3,"sources":["webpack://./src/pages/OnBoxMessage/FileManager.css"],"names":[],"mappings":"AAAA;;UAEU,8EAA8E;UAC9E,WAAW;;UAEX,cAAc;QAChB;;QAEA;UACE,iBAAiB;UACjB,cAAc;QAChB;;QAEA;UACE,cAAc;UACd,kBAAkB;QACpB;;QAEA;UACE,aAAa;UACb,2DAA2D;UAC3D,SAAS;UACT,mBAAmB;QACrB;;QAEA;UACE,iBAAiB;UACjB,kBAAkB;UAClB,aAAa;UACb,yCAAyC;UACzC,aAAa;UACb,mBAAmB;QACrB;;QAEA;UACE,cAAc,EAAE,sBAAsB;UACtC,cAAc;UACd,kBAAkB;UAClB,kBAAkB;QACpB;;QAEA;UACE,SAAS;UACT,iBAAiB;UACjB,cAAc;QAChB;;QAEA;UACE,iBAAiB;UACjB,cAAc;QAChB;;QAEA;UACE,iBAAiB;UACjB,kBAAkB;UAClB,aAAa;UACb,yCAAyC;UACzC,mBAAmB;QACrB;;QAEA;UACE,kBAAkB;UAClB,cAAc;QAChB;;QAEA;UACE,uBAAuB;UACvB,kBAAkB;UAClB,aAAa;UACb,kBAAkB;QACpB;;QAEA;UACE,WAAW;UACX,mBAAmB;QACrB;;QAEA;UACE,mBAAmB;UACnB,YAAY;UACZ,YAAY;UACZ,kBAAkB;UAClB,kBAAkB;UAClB,eAAe;UACf,gBAAgB;QAClB;;QAEA;UACE,mBAAmB;QACrB;;QAEA;UACE,aAAa;UACb,8BAA8B;UAC9B,mBAAmB;UACnB,eAAe;UACf,SAAS;QACX;;QAEA;UACE,aAAa;UACb,sBAAsB;UACtB,kBAAkB;UAClB,YAAY;QACd;;QAEA;UACE,aAAa;UACb,SAAS;QACX;;QAEA;UACE,aAAa;UACb,sBAAsB;UACtB,kBAAkB;UAClB,iBAAiB;QACnB;;QAEA;UACE,iBAAiB;UACjB,kBAAkB;UAClB,yCAAyC;UACzC,gBAAgB;QAClB;;QAEA;UACE,aAAa;UACb,kBAAkB;UAClB,cAAc;QAChB;;QAEA;UACE,WAAW;UACX,yBAAyB;QAC3B;;QAEA;UACE,mBAAmB;UACnB,YAAY;;UAEZ,gBAAgB;UAChB,cAAc;UACd,6BAA6B;QAC/B;;QAEA;UACE,YAAY;UACZ,6BAA6B;QAC/B;;QAEA;UACE,mBAAmB;QACrB;;QAEA;UACE,aAAa;UACb,uBAAuB;QACzB;;QAEA;UACE,cAAc,EAAE,sBAAsB;UACtC,gBAAgB;UAChB,kBAAkB;UAClB,sBAAsB;QACxB;;QAEA;UACE,gBAAgB;UAChB,cAAc;QAChB;;QAEA;UACE,iBAAiB;UACjB,cAAc;UACd,aAAa;QACf;;QAEA;UACE,aAAa;UACb,eAAe;UACf,QAAQ;UACR,eAAe;QACjB;;QAEA;UACE,mBAAmB;UACnB,cAAc;UACd,gBAAgB;UAChB,mBAAmB;UACnB,iBAAiB;QACnB;;QAEA;UACE,cAAc;UACd,gBAAgB;QAClB;;QAEA;UACE,cAAc;UACd,gBAAgB;QAClB;;QAEA;UACE,cAAc;UACd,gBAAgB;QAClB;;QAEA;UACE,cAAc;UACd,gBAAgB;QAClB;;QAEA;UACE,cAAc;UACd,gBAAgB;QAClB;;QAEA;UACE,cAAc;UACd,gBAAgB;QAClB;;QAEA;UACE,cAAc;UACd,gBAAgB;QAClB;;QAEA;UACE,iBAAiB;UACjB,cAAc;UACd,eAAe;QACjB;;QAEA;UACE,aAAa;UACb,QAAQ;QACV;;QAEA;UACE,gBAAgB;UAChB,sBAAsB;UACtB,kBAAkB;UAClB,gBAAgB;UAChB,eAAe;UACf,eAAe;QACjB;;QAEA;UACE,mBAAmB;QACrB;;QAEA;UACE,cAAc;UACd,qBAAqB;QACvB;;QAEA;UACE;YACE,sBAAsB;UACxB;;UAEA;YACE,WAAW;UACb;;UAEA;YACE,WAAW;YACX,8BAA8B;UAChC;;UAEA;YACE,cAAc;YACd,gBAAgB;UAClB;QACF;;;QAGA;EACN,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,+CAA+C;AACjD;AACA;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B","sourcesContent":[".file-manager {\n         \n          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n          color: #333;\n         \n          margin: 0 auto;\n        }\n        \n        h2 {\n          margin: 0 0 5px 0;\n          color: #2c3e50;\n        }\n        \n        .subtitle {\n          color: #7f8c8d;\n          margin: 0 0 25px 0;\n        }\n        \n        .stats-grid {\n          display: grid;\n          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n          gap: 20px;\n          margin-bottom: 30px;\n        }\n        \n        .stat-card {\n          background: white;\n          border-radius: 8px;\n          padding: 20px;\n          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n          display: flex;\n          align-items: center;\n        }\n        \n        .stat-icon {\n          color: #6b7280; /* Tailwind gray-500 */\n          font-size: 2em;\n          margin-bottom: 8px;\n          margin-right: 15px;\n        }\n        \n        .stat-content h3 {\n          margin: 0;\n          font-size: 1.8rem;\n          color: #2c3e50;\n        }\n        \n        .stat-content p {\n          margin: 5px 0 0 0;\n          color: #7f8c8d;\n        }\n        \n        .upload-section {\n          background: white;\n          border-radius: 8px;\n          padding: 20px;\n          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n          margin-bottom: 20px;\n        }\n        \n        .upload-section h3 {\n          margin: 0 0 15px 0;\n          color: #2c3e50;\n        }\n        \n        .upload-area {\n          border: 2px dashed #ddd;\n          border-radius: 8px;\n          padding: 20px;\n          text-align: center;\n        }\n        \n        .file-input {\n          width: 100%;\n          margin-bottom: 15px;\n        }\n        \n        .upload-button {\n          background: #3498db;\n          color: white;\n          border: none;\n          padding: 10px 20px;\n          border-radius: 4px;\n          cursor: pointer;\n          margin-top: 15px;\n        }\n        \n        .upload-button:hover {\n          background: #2980b9;\n        }\n        \n        .filters-section {\n          display: flex;\n          justify-content: space-between;\n          margin-bottom: 20px;\n          flex-wrap: wrap;\n          gap: 15px;\n        }\n        \n        .search-box input {\n          padding: 10px;\n          border: 1px solid #ddd;\n          border-radius: 4px;\n          width: 250px;\n        }\n        \n        .filter-group {\n          display: flex;\n          gap: 10px;\n        }\n        \n        .filter-group select {\n          padding: 10px;\n          border: 1px solid #ddd;\n          border-radius: 4px;\n          background: white;\n        }\n        \n        .files-table-container {\n          background: white;\n          border-radius: 8px;\n          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n          overflow: hidden;\n        }\n        \n        .loading, .no-files {\n          padding: 40px;\n          text-align: center;\n          color: #7f8c8d;\n        }\n        \n        .files-table {\n          width: 100%;\n          border-collapse: collapse;\n        }\n        \n        .files-table th {\n          background: #f8f9fa;\n          padding: 8px;\n         \n          font-weight: 600;\n          color: #2c3e50;\n          border-bottom: 1px solid #ddd;\n        }\n        \n        .files-table td {\n          padding: 8px;\n          border-bottom: 1px solid #eee;\n        }\n        \n        .files-table tr:hover {\n          background: #f8f9fa;\n        }\n        \n        .file-info {\n          display: flex;\n          align-items: flex-start;\n        }\n        \n        .file-icon {\n          color: #6b7280; /* Tailwind gray-500 */\n          font-size: 1.5em;\n          margin-right: 10px;\n          vertical-align: middle;\n        }\n        \n        .file-title {\n          font-weight: 600;\n          color: #2c3e50;\n        }\n        \n        .file-name {\n          font-size: 0.9rem;\n          color: #7f8c8d;\n          margin: 2px 0;\n        }\n        \n        .file-tags {\n          display: flex;\n          flex-wrap: wrap;\n          gap: 5px;\n          margin-top: 5px;\n        }\n        \n        .tag {\n          background: #e8f4fd;\n          color: #3498db;\n          padding: 2px 8px;\n          border-radius: 12px;\n          font-size: 0.8rem;\n        }\n        \n        .vault.internal {\n          color: #27ae60;\n          font-weight: 600;\n        }\n        \n        .vault.external {\n          color: #3498db;\n          font-weight: 600;\n        }\n        \n        .status.active {\n          color: #27ae60;\n          font-weight: 600;\n        }\n        \n        .status.processing {\n          color: #f39c12;\n          font-weight: 600;\n        }\n        \n        .access.public {\n          color: #27ae60;\n          font-weight: 600;\n        }\n        \n        .access.restricted {\n          color: #f39c12;\n          font-weight: 600;\n        }\n        \n        .access.confidential {\n          color: #e74c3c;\n          font-weight: 600;\n        }\n        \n        .uploader {\n          font-size: 0.8rem;\n          color: #7f8c8d;\n          margin-top: 3px;\n        }\n        \n        .actions {\n          display: flex;\n          gap: 8px;\n        }\n        \n        .actions button {\n          background: none;\n          border: 1px solid #ddd;\n          border-radius: 4px;\n          padding: 5px 8px;\n          cursor: pointer;\n          font-size: 1rem;\n        }\n        \n        .actions button:hover {\n          background: #f8f9fa;\n        }\n        \n        .delete-btn:hover {\n          color: #e74c3c;\n          border-color: #e74c3c;\n        }\n        \n        @media (max-width: 768px) {\n          .filters-section {\n            flex-direction: column;\n          }\n          \n          .search-box input {\n            width: 100%;\n          }\n          \n          .filter-group {\n            width: 100%;\n            justify-content: space-between;\n          }\n          \n          .files-table {\n            display: block;\n            overflow-x: auto;\n          }\n        }\n\n\n        .file-manager-container {\n  padding: 20px;\n  max-width: 100%;\n  margin: 100px auto 0;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.file-manager-header {\n  margin-bottom: 24px;\n}\n\n.file-manager-header h2 {\n  color: #2c3e50;\n  margin: 0 0 8px 0;\n  font-weight: 600;\n}\n\n.subtitle {\n  color: #7f8c8d;\n  margin: 0;\n  font-size: 16px;\n}\n\n.controls-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.search-box {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1;\n  min-width: 300px;\n  max-width: 500px;\n}\n\n.search-icon {\n  position: absolute;\n  left: 12px;\n  color: #95a5a6;\n}\n\n.search-box input {\n  width: 100%;\n  padding: 10px 15px 10px 40px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.3s;\n}\n\n.search-box input:focus {\n  outline: none;\n  border-color: #3498db;\n  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);\n}\n\n.controls-right {\n  display: flex;\n  gap: 10px;\n}\n\n.refresh-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background-color: #ecf0f1;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.refresh-btn:hover:not(:disabled) {\n  background-color: #dfe6e9;\n}\n\n.refresh-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.table-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n}\n\n.table-responsive {\n  overflow-x: auto;\n  width: 100%;\n}\n\n.messages-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 800px;\n}\n\n.messages-table th {\n  background-color: #f8f9fa;\n  padding: 12px 15px;\n  text-align: left;\n  font-weight: 600;\n  color: #2c3e50;\n  border-bottom: 2px solid #e9ecef;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  position: relative;\n}\n\n.messages-table th:hover {\n  background-color: #e9ecef;\n}\n\n.column-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.sort-indicator {\n  margin-left: 5px;\n  font-weight: bold;\n}\n\n.messages-table td {\n  padding: 12px 15px;\n  border-bottom: 1px solid #e9ecef;\n  vertical-align: top;\n  font-size: 14px;\n  color: #34495e;\n  max-width: 300px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.messages-table tr:hover {\n  background-color: #f8f9fa;\n}\n\n.array-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.array-item {\n  background-color: #e3f2fd;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #1976d2;\n}\n\n.truncate-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.action-btn {\n  padding: 6px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.action-btn.view {\n  background-color: #e3f2fd;\n  color: #1976d2;\n}\n\n.action-btn.download {\n  background-color: #e8f5e9;\n  color: #388e3c;\n}\n\n.action-btn.delete {\n  background-color: #ffebee;\n  color: #d32f2f;\n}\n\n.action-btn:hover {\n  opacity: 0.8;\n  transform: scale(1.05);\n}\n\n.loading-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #3498db;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  color: #95a5a6;\n  text-align: center;\n}\n\n.empty-state h3 {\n  margin: 16px 0 8px;\n  color: #7f8c8d;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  padding: 20px;\n  gap: 8px;\n}\n\n.pagination button {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  background-color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.pagination button:hover:not(:disabled):not(.active) {\n  background-color: #f1f1f1;\n}\n\n.pagination button.active {\n  background-color: #3498db;\n  color: white;\n  border-color: #3498db;\n}\n\n.pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.table-info {\n  padding: 0 20px 20px;\n  text-align: center;\n  color: #7f8c8d;\n  font-size: 14px;\n}\n\n@media (max-width: 768px) {\n  .file-manager-container {\n    padding: 15px;\n    margin-top: 80px;\n  }\n  \n  .controls-section {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .search-box {\n    min-width: 100%;\n  }\n  \n  .messages-table th, \n  .messages-table td {\n    padding: 8px 10px;\n    font-size: 13px;\n  }\n  \n  .action-buttons {\n    flex-direction: column;\n    gap: 4px;\n  }\n}\n\n.bareedy-card {\n  transition: box-shadow 0.2s;\n}\n.bareedy-card:hover {\n  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.12);\n}\n.action-btn {\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.action-btn:hover {\n  filter: brightness(0.95);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
